import React from 'react';

const GlobalLoader = () => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black">
            <div className="w-[120px] h-[120px] md:w-[200px] md:h-[200px]">
                <svg
                    id="Camada_1"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    viewBox="0 0 1291.45 1352.08"
                    style={{ width: '100%', height: '100%' }}
                >
                    <defs>
                        <style>
                            {`
                :root {
                  --tech-blue: #0531c2;
                  --tech-white: #fefefd;
                  --total-dur: 18s; 
                }
                
                .st0 {
                  fill: var(--tech-white);
                  stroke: var(--tech-white);
                  stroke-width: 4;
                  fill-opacity: 0;
                }
                .st1 {
                  fill: var(--tech-blue);
                  stroke: var(--tech-blue);
                  stroke-width: 4;
                  fill-opacity: 0;
                }
          
                /* Layers */
                .glitch-group {
                  filter: url(#glitch);
                }
                
                .vector-anim {
                  stroke-dasharray: 1;
                  stroke-dashoffset: 1;
                  opacity: 0;
                  animation: vectorDraw var(--total-dur) linear infinite;
                }
          
                .circle-anim {
                  stroke-dasharray: 1;
                  stroke-dashoffset: 1;
                  opacity: 0;
                  animation: circleDraw var(--total-dur) linear infinite;
                }
          
                @keyframes vectorDraw {
                  0% { stroke-dashoffset: 1; opacity: 0; fill-opacity: 0; stroke-width: 4; }
                  1% { opacity: 1; }
                  10% { stroke-dashoffset: 0; opacity: 1; fill-opacity: 0; stroke-width: 4; }
                  11% { stroke-dashoffset: 0; opacity: 1; fill-opacity: 1; stroke-width: 0; }
                  94% { stroke-dashoffset: 0; opacity: 1; fill-opacity: 1; stroke-width: 0; }
                  100% { stroke-dashoffset: 0; opacity: 0; fill-opacity: 1; stroke-width: 0; }
                }
          
                @keyframes circleDraw {
                  0% { stroke-dashoffset: 1; opacity: 0; fill-opacity: 0; stroke-width: 4; }
                  1% { opacity: 1; }
                  10% { stroke-dashoffset: 0; opacity: 1; fill-opacity: 0; stroke-width: 4; }
                  11% { stroke-dashoffset: 0; opacity: 1; fill-opacity: 1; stroke-width: 0; }
                  14% { opacity: 0; }
                  100% { opacity: 0; }
                }
              `}
                        </style>
                        <filter id="glitch" x="-20%" y="-20%" width="140%" height="140%">
                            <feTurbulence
                                type="fractalNoise"
                                baseFrequency="0 0.8"
                                numOctaves="1"
                                result="noise"
                            />
                            <feDisplacementMap
                                in="SourceGraphic"
                                in2="noise"
                                scale="0"
                                xChannelSelector="R"
                                yChannelSelector="R"
                            >
                                <animate
                                    attributeName="scale"
                                    values="0; 0; 50; -50; 0; 0; 0; 0; 0"
                                    keyTimes="0; 0.05; 0.08; 0.09; 0.11; 0.94; 0.96; 0.98; 1"
                                    dur="18s"
                                    repeatCount="indefinite"
                                />
                            </feDisplacementMap>
                        </filter>
                    </defs>
                    <g className="glitch-group">
                        <circle
                            className="st1 circle-anim"
                            cx="655.31"
                            cy="687.83"
                            r="565.35"
                            pathLength="1"
                        />
                        <path
                            className="st0 vector-anim"
                            d="M679.68,259.24v102.32c0,4.96,19.87.83,23.82.64,3.2-.15,13.1,2.76,13.1-.64v-97.7c123.56,15.93,239.01,90.91,302.91,197.51l-186.7,141.02c-24.37-48-65.81-82.52-116.21-100.82v-46.93c47.5,10.49,87.79,37.43,120.8,72.29,2.3,2.43,4.03,7.78,7.64,7.74l109.92-82.5c.85-3.47-28.13-34.47-32.92-39.12-42.93-41.61-101.28-76.34-159.28-90.74v53.85h28.46c5.05,0,49.55,38.8,57.78,43.85,12.67-.31,23.51-3.21,34.53,5.38,34.12,26.64-10.88,77.6-42.36,46.97-9.36-9.11-6.73-21.29-11.35-27.11-9.04-11.37-36.53-25.54-47.83-36.79h-100.01c-.16,0-2.31,2.14-2.31,2.31v85.39c-153.16-15.94-260.31,154.2-182.2,287.59,70,119.53,238.55,128,318.85,14.46,6.13-8.67,10.1-17.31,15.33-26.22.74-1.27-.46-2.57,2.6-1.93l185.47,143.76c-64.55,107.31-179.41,180.66-303.13,199.31v-100.01h-36.93v103.08c-146.67,7.75-287.48-62.63-372.05-181.07-134.27-188.04-92.71-450.38,90.62-588.86,80.78-61.01,179.85-91.27,281.43-87.06ZM633.52,306.93c-88.06,4.44-173.17,42.31-236.94,102.32v90.01l20.73-15.42c33.97-33.54,79.03-62.01,112.39-95.32,8.73-8.72,3.07-14.91,9.67-25.72,16.46-26.96,58.8-14.62,58.19,16.98-.46,23.83-22.65,34.61-44.13,29.55l-156.86,133.79v85.39h-46.16v-166.17c-44.68,56.64-70.28,130.73-73.85,203.09h149.24c9.47-109.47,98.18-203.23,207.71-215.4v-143.09ZM425.81,711.58h-149.24c3.92,72.42,29.35,144.51,73.85,201.55v-166.17h46.16v85.39l157,133.92c19.55-4.36,40.97,4.49,43.09,26.01,4.09,41.43-51.78,48.2-61.26,10.5-1.08-4.28,1.16-9.54-2.58-12.81l-136.25-115.31v91.55c64.95,59.32,148.2,97.96,236.94,102.32v-144.63c-109.32-12.53-195.45-104.01-207.71-212.32ZM762.76,1054.68c67.04-20.46,137.17-61.13,181.51-116.2,2.34-2.91,11.6-13.19,10.15-16.08l-109.36-84.37c-37.28,44.6-84.64,73.01-142.02,83.86-4.2.79-23.36,2.02-23.36,4.33v39.23h99.24c.4,0,1.28.9,2.45.76,3.06-.37,45.73-32.95,49.07-36.94,6.02-7.22.89-25.06,18.96-33.36,34.27-15.75,60.91,27.43,36.3,50.15-11.21,10.35-22.93,8.39-36.74,7.84-7.11,5.07-52.58,45.39-56.19,45.39h-30v55.39Z"
                            pathLength="1"
                        />
                    </g>
                </svg>
            </div>
        </div>
    );
};

export default GlobalLoader;
